import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import PropTypes from 'prop-types';

import PluginSetFilters from './containers/plugin_set_filters';

export default class PluginSetEditor extends React.Component {
  static propTypes = {
    filterFieldOptions: PropTypes.object.isRequired,
    pluginSet: PropTypes.shape({
      id: PropTypes.number,
      pluginFilters: PropTypes.array,
    }).isRequired,
    propertyTypes: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.store = createStore(reducers, { pluginSet: props.pluginSet }, applyMiddleware(thunk));
    if (module.hot) {
      module.hot.accept('./reducers/index', () => {
        this.store.replaceReducer(require('./reducers/index'));
      });
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <PluginSetFilters
          filterFieldOptions={this.props.filterFieldOptions}
          propertyTypes={this.props.propertyTypes}
        />
      </Provider>
    );
  }
}
